"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "app",
    attrs: {
      id: "app"
    }
  }, [!_vm.$route.meta.layoutFull ? _c("layout") : _c("layout-full")], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;